import { MaterialDailyReportStateTypes, MaterialDailyReportActionTypes } from "./MaterialDailyReport.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: MaterialDailyReportStateTypes = {
  fetchAll: resetApiCallState([]),
  fetchOne: resetApiCallState({}),
};

const MaterialDailyReportReducer = (
  state: MaterialDailyReportStateTypes = INITIAL_STATE,
  action: any
): MaterialDailyReportStateTypes => {
  switch (action.type) {
    case MaterialDailyReportActionTypes.FETCH_ALL_MATERIAL_DAILY_REPORT:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case MaterialDailyReportActionTypes.FETCH_ALL_MATERIAL_DAILY_REPORT_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case MaterialDailyReportActionTypes.FETCH_ALL_MATERIAL_DAILY_REPORT_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case MaterialDailyReportActionTypes.FETCH_ALL_MATERIAL_DAILY_REPORT_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    case MaterialDailyReportActionTypes.FETCH_ONE_MATERIAL_DAILY_REPORT:
      return {
        ...state,
        fetchOne: {
          error: null,
          payload: {},
          isPending: true,
          isSuccessful: false,
        },
      };
    case MaterialDailyReportActionTypes.FETCH_ONE_MATERIAL_DAILY_REPORT_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case MaterialDailyReportActionTypes.FETCH_ONE_MATERIAL_DAILY_REPORT_FAILURE:
      return {
        ...state,
        fetchOne: {
          payload: {},
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case MaterialDailyReportActionTypes.FETCH_ONE_MATERIAL_DAILY_REPORT_SUCCESS:
      return {
        ...state,
        fetchOne: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default MaterialDailyReportReducer;
